import React, { useState } from 'react';
import CustomRefinementList from './CustomRefinementList';
import CustomSearchBox from './CustomSearchBox';
import {
    InstantSearch,
    SearchBox,
    Pagination,
    RefinementList,
    useHits
} from 'react-instantsearch';
import CustomHits from "../Recherche_avance/CustomHits";

import DomainsListCom from "../Domains/DomainsListCom";
import CustomStats from "./CustomStats";
import { algoliaSearchClient, ALGOLIA_INDEX_FICHES } from "../../api/algolia";

<CustomHits/>

function Search() {
    return (
        <InstantSearch indexName={ALGOLIA_INDEX_FICHES} searchClient={algoliaSearchClient}>
            <div className="row" style={{background: "#066fd1", padding: "2rem", marginTop: "-1.5rem"}}>
                <div className="col-12">
                    <h1 style={{color:"white"}}>Recherche</h1>
                    <h3 style={{color:"white"}}>Recherche Simple</h3>
                    <CustomSearchBox />
                </div>
            </div>
            <div className="row">
                <div className="col-3" style={{border: "5px solid #066fd1", borderTopWidth: "0px"}}>
                    <h1><CustomStats/></h1>
                    <br/>
                    <CustomRefinementList title="Commission"
                                          attribute="domaine"
                                          searchablePlaceholder="Rechercher un commission"/>
                    <CustomRefinementList title="Domaine"
                                          attribute="domaine"
                                          searchablePlaceholder="Rechercher un domaine"/>
                    <CustomRefinementList title="Sous domaine"
                                          attribute="sous_domaine"
                                          searchablePlaceholder="Rechercher un sous-domaine"/>
                </div>
                <div className="col-9 align-center">
                    <CustomHits editable />
                    <Pagination
                        classNames={{
                            list: "pagination",
                            item: "page-item",
                            link: "page-link",
                            selectedItem: "active",
                            disabledItem: "disabled",
                        }}
                    />
                </div>
            </div>
        </InstantSearch>
    );
}

export default Search;
